export { default as MaterialsIndexPageCategoriesNav } from './MaterialsIndexPageCategoriesNav';
